import { ProductCheckListDataRow } from '../../../types';

export const isRowActive = (row: ProductCheckListDataRow): boolean => !row.allClaimed;
